import { styled } from '@mui/material';

const Container = styled('div')`
  max-width: 1136px;
  margin: 0 auto;
  padding: 0 24px;
  padding-bottom: 40px;

  ${({ theme }) => theme.breakpoints.up('lg')} {
    padding: 0;
    padding-bottom: 40px;
  }
`;

export default Container;
